var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('web3-utils'),
    fromWei = _require.fromWei,
    toWei = _require.toWei;

var pricefeed = require('./pricefeed');

var _require2 = require('./utils/decimals'),
    toDecimal = _require2.toDecimal;

var PRICE_POLL_INTERVAL = 15 * 1000;

var Asset =
/*#__PURE__*/
function () {
  "use strict";

  function Asset(_ref) {
    var id = _ref.id,
        name = _ref.name,
        network = _ref.network,
        usdPrice = _ref.usdPrice,
        priceSymbol = _ref.priceSymbol,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? null : _ref$type,
        _ref$decimals = _ref.decimals,
        decimals = _ref$decimals === void 0 ? 18 : _ref$decimals;

    _classCallCheck(this, Asset);

    this.id = id;
    this.name = name;
    this.network = network;
    this.usdPrice = usdPrice;
    this.priceSymbol = priceSymbol;
    this.type = type;
    this.decimals = decimals;
    this.cleanupFunctions = [];

    if (priceSymbol) {
      this._startPricePolling();
    }
  }

  _createClass(Asset, [{
    key: "setCore",
    value: function setCore(core) {
      this.core = core;
    }
  }, {
    key: "supportsMessages",
    value: function supportsMessages() {
      return false;
    }
  }, {
    key: "getTx",
    value: function () {
      var _getTx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(txHash) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                throw new Error('Not implemented');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getTx(_x) {
        return _getTx.apply(this, arguments);
      }

      return getTx;
    }()
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue(value) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var displayVal = toDecimal(value.toString(), this.decimals);

      if (displayVal.indexOf('.') !== -1) {
        return displayVal.substr(0, displayVal.indexOf('.') + decimals + 1);
      }

      return displayVal;
    }
  }, {
    key: "getUSDValue",
    value: function getUSDValue(value) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      if (this.usdPrice) {
        return (+this.getDisplayValue(value, 10) * this.usdPrice).toFixed(decimals);
      }

      throw new Error('USD price not available');
    }
  }, {
    key: "getBalance",
    value: function () {
      var _getBalance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(account) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error('getBalance not implemented');

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getBalance(_x2) {
        return _getBalance.apply(this, arguments);
      }

      return getBalance;
    }()
  }, {
    key: "getDisplayBalance",
    value: function () {
      var _getDisplayBalance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(account) {
        var decimals,
            balance,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                decimals = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 2;
                _context3.next = 3;
                return this.getBalance(account);

              case 3:
                balance = _context3.sent;
                return _context3.abrupt("return", this.getDisplayValue(balance, decimals));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getDisplayBalance(_x3) {
        return _getDisplayBalance.apply(this, arguments);
      }

      return getDisplayBalance;
    }()
  }, {
    key: "getUSDBalance",
    value: function () {
      var _getUSDBalance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(account) {
        var decimals,
            balance,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                decimals = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 2;
                _context4.next = 3;
                return this.getBalance(account);

              case 3:
                balance = _context4.sent;
                return _context4.abrupt("return", this.getUSDValue(balance, decimals));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getUSDBalance(_x4) {
        return _getUSDBalance.apply(this, arguments);
      }

      return getUSDBalance;
    }()
  }, {
    key: "startWatchingAddress",
    value: function startWatchingAddress(address) {
      throw new Error('watching not implemented');
    }
  }, {
    key: "send",
    value: function () {
      var _send2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(params) {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (params.ether) {
                  params.value = toWei(params.ether, 'ether');
                  delete params.ether;
                }

                _context5.next = 3;
                return this._send(params);

              case 3:
                response = _context5.sent;
                this.core.addHistoryEvent({
                  asset: this.id,
                  type: 'send',
                  value: params.value,
                  from: params.from,
                  to: params.to,
                  tx: response.txHash,
                  message: params.message || null,
                  timestamp: Date.now() / 1000
                });
                return _context5.abrupt("return", response);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function send(_x5) {
        return _send2.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "_send",
    value: function () {
      var _send3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(_ref2) {
        var from, to, value;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                from = _ref2.from, to = _ref2.to, value = _ref2.value;
                throw new Error('send not implemented');

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function _send(_x6) {
        return _send3.apply(this, arguments);
      }

      return _send;
    }()
  }, {
    key: "_startPricePolling",
    value: function () {
      var _startPricePolling2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this = this;

        var interval;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                interval = setInterval(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee7() {
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return pricefeed.getPrice(_this.priceSymbol);

                        case 2:
                          _this.usdPrice = _context7.sent;

                        case 3:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                })), PRICE_POLL_INTERVAL);
                this.cleanupFunctions.push(function () {
                  return clearInterval(interval);
                });
                _context8.next = 4;
                return pricefeed.getPrice(this.priceSymbol);

              case 4:
                this.usdPrice = _context8.sent;

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _startPricePolling() {
        return _startPricePolling2.apply(this, arguments);
      }

      return _startPricePolling;
    }()
  }, {
    key: "getWeb3",
    value: function getWeb3(options) {
      return this.core.getWeb3(this.network, options);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.cleanupFunctions.forEach(function (fn) {
        return fn();
      });
    }
  }]);

  return Asset;
}();

module.exports = Asset;